import { overlaps } from '../../utils/overlaps';
import { ActionData } from '../entities';

export enum Validation {
	InsufficientBalance = 'insufficient_balance',
	InvalidAmount = 'invalid_amount',
	MissingAmount = 'missing_amount',
	MissingHashtag = 'missing_hashtag',
	MissingRecipient = 'missing_recipient',
	MissingRequiredHashtag = 'missing_required_hashtag',
	ServerError = 'server_error',
}

export class ValidationError {
	constructor(
		public id: string,
		public data?: any
	) {}
}

export class ActionValidation {
	public errors: ValidationError[] = [];

	add(id: Validation, data?: any) {
		this.errors.push(new ValidationError(id, data));
	}

	isValid() {
		return !this.errors.length;
	}
}

export interface ValidatorConfig {
	requireAmount?: boolean;
	requireBalance?: number | null;
	requireHashtag?: boolean | string[];
	requirePositiveAmount?: boolean;
	requireRecipient?: boolean;
}

export class ActionValidator {
	public readonly requireAmount;
	public readonly requireBalance;
	public readonly requireHashtag;
	public readonly requirePositiveAmount;
	public readonly requireRecipient;

	constructor({
		requireAmount = false,
		requireBalance = null,
		requireHashtag = false,
		requirePositiveAmount = false,
		requireRecipient = false,
	}: ValidatorConfig) {
		this.requireAmount = requireAmount;
		this.requireBalance = requireBalance;
		this.requireHashtag = requireHashtag;
		this.requirePositiveAmount = requirePositiveAmount;
		this.requireRecipient = requireRecipient;
	}

	validate(data: ActionData) {
		const validation = new ActionValidation();

		if (typeof this.requireBalance === 'number' && data.totalAmount > this.requireBalance) {
			validation.add(Validation.InsufficientBalance, data.totalAmount);
		}

		if (this.requireAmount && !data.hasAmount) {
			validation.add(Validation.MissingAmount);
		}

		if (this.requirePositiveAmount && !data.amount) {
			validation.add(Validation.InvalidAmount);
		}

		if (this.requireHashtag === true && !data.hasHashtag) {
			validation.add(Validation.MissingHashtag);
		}

		if (Array.isArray(this.requireHashtag) && !overlaps(this.requireHashtag, data.hashtags)) {
			validation.add(Validation.MissingRequiredHashtag, this.requireHashtag);
		}

		return validation;
	}
}
